import React, {PropTypes, Component} from 'react';
import _, {get} from 'lodash';
import { connect } from 'react-redux';

// components
import TextArea from '../../../../../common/components/c_TextArea';
import RatingStars from '../../../../../common/components/c_RatingStars';


@connect(store => {
  return {
    labels: get(store, 'labels.Ratings', {})
  };
})
export default class Ratings extends Component  {

  static propTypes = {
    staticData: PropTypes.object,
    script: PropTypes.bool,
    applicant: PropTypes.object,
    ratings: PropTypes.object,
    updateTempState: PropTypes.func,
    model: PropTypes.string.isRequired,
    tempState: PropTypes.object,
    labels: PropTypes.object,
    saveData: PropTypes.func
  };

  constructor() {

    super();
    this.onChange = ::this.onChange;
    this.onBlur = ::this.onBlur;
    this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
    this.averageRating = ::this.averageRating;
  }

  onChange(prop, rid) {
    return (event, value) => {
      this.props.saveData({ratings: _.set({}, `${rid}.${prop}`, value)});
    };
  }

  onBlur(model, prop) {
    return (event, value) => {
      this.props.saveData(_.set({}, `${model}.${prop}`, value));
    };
  }

  handleDropDownMenuUI(ratingItem, prop, label) {
    return {
      defaultValue: _.get(this.props.ratings[ratingItem.id], prop),
      value: _.get(this.props.ratings[ratingItem.id], prop),
      floatingLabelText: label,
      onChange: this.onChange(prop, ratingItem.id),
      id: `interview-rating-${ratingItem.id}`,
      disabled: false // Client wants rating regardless status.
    };
  }

  isInterviewGroup(groupId) {
    return !_.isNil(this.props.staticData.ratingGroups.find(
      ratingGroup => ratingGroup.id === groupId && ['Group One', 'Group Two'].includes(ratingGroup.name)));
  }

  averageRating() {
    const overalRatings = _.filter(_.merge({}, this.props.ratings, _.get(this.props.tempState, this.props.model) || {}),
      (rating) => {
        return (this.isInterviewGroup(rating.groupId) || _.isNil(rating.groupId));
    });
    const total = _.reduce(overalRatings, (sum, n) => {
      return sum + parseInt(n.rating, 10);
    }, 0);
    const average = total/Object.keys(overalRatings).length;
    return Math.round(average) || 0;
  }

  render() {
    const script = this.props.script;
    const interviewRatingGroups = _.keyBy(this.props.staticData.ratingGroups, 'id');
    const interviewRatings = this.props.staticData.ratingTypes;
    const groupedRatings = _.reduce(interviewRatings, (result, rating) => {
      if (this.isInterviewGroup(rating.groupId)) {
        (result[rating.groupId] || (result[rating.groupId] = [])).push(rating);
      }
      return result;
    }, {});


  // Only enable rating for "Active" and "Not Qualified" applicants.
  // const ratingDisabled = ([8, 11].indexOf(this.props.applicant.profile.applicantStatus.id) < 0);

  function mapObject(object, callback) {
    return Object.keys(object).map((key) => {
      return callback(object[key], key);
    });
  }

  return (
    <div className='expanded-accordion-content explanation-of-wahve'
      key={`ratings ${this.props.applicant.profile.id}`}>
      <div data-id='Instructions 1'
           className='callout ratings-instruction'
           style={{paddingBottom: !script ? 0 : null}}>
        <div className='title'><b>Instructions:</b></div>
        <div className='text'>
          {this.props.labels.intro}
        </div>
      </div>
      {
        mapObject(groupedRatings, (groupedRating, groupId) =>
          <div className='callout rating-group' data-id={(_.get(interviewRatingGroups[groupId], 'name') || '')} >
            <div className='group-name'>{(_.get(interviewRatingGroups[groupId], 'name') || '')}</div>
            {
              groupedRating.map((ratingItem, ratingKey) =>
              <RatingStars
                className='rating-item'
                {...this.handleDropDownMenuUI(ratingItem, 'rating', ratingItem.name)}
              />
              )
            }
          </div>
        )
      }
      <div className='final-rating callout' data-id='Final Rating' >
        <div className='title'>Final Rating</div>
          <RatingStars
            className='rating-item'
            value={this.averageRating()}
            floatingLabelText='Overall Rating'
            id='overal-interview-rating'
            readOnly='true'
          />
      </div>
      <div className='rating-comments callout'>
        <div className='title'>Rating Comments</div>
        <TextArea
          defaultValue={typeof _.get(this.props.tempState, 'profile.ratingComments') === 'string' ? this.props.tempState.profile.ratingComments : this.props.applicant.profile.ratingComments}
          onBlur={this.onBlur('profile', 'ratingComments')}
          data-id={'rating-comments'}
        />
      </div>
    </div>
  );
}

}


// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_Ratings/index.js